import React, { useState } from 'react';
import { Table, Button, Card, Form, Row, Col, Collapse } from 'react-bootstrap';
import { FaPlus, FaTrash, FaChevronDown, FaChevronRight } from 'react-icons/fa';
import Select from 'react-select';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

const GridContasProjeto = ({ codigoFamilia, contasProjeto, permissoes, onRecarregar }) => {
  const [aberto, setAberto] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [geValue, setGeValue] = useState('');
  const [contaSelected, setContaSelected] = useState(null);
  const [percentual, setPercentual] = useState('');
  const [contasOptions, setContasOptions] = useState([]);
  const [carregandoContas, setCarregandoContas] = useState(false);
  const [salvando, setSalvando] = useState(false);

  const carregarContas = async (ge) => {
    setContaSelected(null);
    setContasOptions([]);
    if (!ge) return;
    setCarregandoContas(true);
    try {
      const res = await api.listarContasProjetoLookup(ge);
      const dados = res.data != null ? res.data : res;
      const opts = (Array.isArray(dados) ? dados : []).map((c) => ({
        value: c.codigo,
        label: c.codigo + ' - ' + c.descricao,
        codigo: c.codigo,
      }));
      setContasOptions(opts);
    } catch (err) {
      toast.error('Erro ao carregar contas');
    } finally {
      setCarregandoContas(false);
    }
  };

  const handleIncluir = async () => {
    if (!geValue || contaSelected == null) {
      toast.error('Informe GE e Conta.');
      return;
    }
    setSalvando(true);
    try {
      await api.incluirContaProjetoConfig({
        codigo_familia: codigoFamilia,
        codigo_grupo_empresa: Number(geValue),
        codigo_conta: contaSelected.codigo,
        percentual: percentual !== '' ? Number(percentual) : null,
      });
      toast.success('Conta incluída no projeto!');
      setShowForm(false);
      setGeValue('');
      setContaSelected(null);
      setPercentual('');
      setContasOptions([]);
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao incluir conta';
      toast.error(msg);
    } finally {
      setSalvando(false);
    }
  };


  const handleExcluir = async (item) => {
    if (!window.confirm('Excluir a conta "' + item.apelido_conta + '" do projeto?')) return;
    try {
      await api.excluirContaProjetoConfig({
        codigo_familia: codigoFamilia,
        codigo_grupo_empresa: item.codigo_grupo_empresa,
        codigo_conta: item.codigo_conta,
      });
      toast.success('Conta removida do projeto!');
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao excluir conta';
      toast.error(msg);
    }
  };

  const lista = contasProjeto != null ? contasProjeto : [];

  return (
    <Card className="mb-3">
      <Card.Header
        className="d-flex justify-content-between align-items-center py-2"
        style={{ cursor: 'pointer' }}
        onClick={() => setAberto(!aberto)}
      >
        <strong>
          {aberto ? <FaChevronDown size={12} className="mr-2" /> : <FaChevronRight size={12} className="mr-2" />}
          Contas do Projeto
        </strong>
        <span className="text-muted small">{lista.length} conta(s)</span>
      </Card.Header>
      <Collapse in={aberto}>
        <Card.Body className="p-0">
          <div className="p-2">
            {permissoes.projeto && !showForm && (
              <Button size="sm" variant="outline-success" className="mb-2" onClick={() => setShowForm(true)}>
                <FaPlus className="mr-1" /> Incluir Conta
              </Button>
            )}
            {showForm && (
              <div className="p-3 mb-2 border rounded bg-light">
                <Row>
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>GE *</Form.Label>
                      <Form.Control
                        size="sm"
                        type="number"
                        value={geValue}
                        onChange={(e) => setGeValue(e.target.value)}
                        onBlur={() => carregarContas(geValue)}
                        placeholder="Código GE"
                      />
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Conta *</Form.Label>
                      <Select
                        options={contasOptions}
                        value={contaSelected}
                        onChange={setContaSelected}
                        placeholder={carregandoContas ? 'Carregando...' : 'Selecione conta...'}
                        isDisabled={!geValue || carregandoContas}
                        isClearable
                      />
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>% Percentual</Form.Label>
                      <Form.Control type="number" step="0.01" value={percentual} onChange={(e) => setPercentual(e.target.value)} />
                    </Form.Group>
                  </Col>
                  <Col md={3} className="d-flex align-items-end">
                    <Button size="sm" variant="success" className="mr-2" onClick={handleIncluir} disabled={salvando}>
                      <FaPlus className="mr-1" /> Incluir
                    </Button>
                    <Button size="sm" variant="secondary" onClick={() => setShowForm(false)} disabled={salvando}>
                      Cancelar
                    </Button>
                  </Col>
                </Row>
              </div>
            )}
            <div style={{ maxHeight: 300, overflowY: 'auto' }}>
            <Table striped bordered hover size="sm" className="mb-0">
              <thead>
                <tr>
                  <th style={{ width: 80 }}>GE</th>
                  <th style={{ width: 100 }}>Conta</th>
                  <th>Descrição</th>
                  <th style={{ width: 120 }}>% Percentual</th>
                  {permissoes.projeto && <th style={{ width: 60 }}>Ação</th>}
                </tr>
              </thead>
              <tbody>
                {lista.length === 0 && (
                  <tr>
                    <td colSpan={permissoes.projeto ? 5 : 4} className="text-center text-muted">Nenhuma conta vinculada</td>
                  </tr>
                )}
                {lista.map((item) => (
                  <tr key={item.codigo_grupo_empresa + '-' + item.codigo_conta}>
                    <td>{item.codigo_grupo_empresa}</td>
                    <td>{item.codigo_conta}</td>
                    <td>{item.apelido_conta}</td>
                    <td>{item.percentual != null ? item.percentual : '-'}</td>
                    {permissoes.projeto && (
                      <td>
                        <Button size="sm" variant="outline-danger" title="Excluir" onClick={() => handleExcluir(item)}>
                          <FaTrash />
                        </Button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
            </div>
          </div>
        </Card.Body>
      </Collapse>
    </Card>
  );
};

export default GridContasProjeto;
